import { useEffect } from 'react';

import { useBaseInput } from '../VBaseInput';
import type { DATEPICKER_MODE } from './constant';
import useVDatePickerContext from './hook';
import style from './style';
import type { VDatePickerProps } from './type';

const VDatePickerInput = ({
  disabled,
  placeholder,
  valid,
}: Pick<
  VDatePickerProps<DATEPICKER_MODE.RANGE>,
  'disabled' | 'placeholder' | 'valid'
>) => {
  const { size, status, setStatus } = useBaseInput();
  const { value, onChange } = useVDatePickerContext<DATEPICKER_MODE.SINGLE>();

  useEffect(() => {
    setStatus(prev => ({ ...prev, disabled, valid }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled, valid]);

  return (
    <input
      className={style.vDatePickerInput({ size })}
      disabled={status.disabled ?? false}
      placeholder={placeholder}
      readOnly={status.readOnly ?? false}
      value={value}
      onChange={e => onChange(e.target.value)}
      onFocus={() => setStatus({ ...status, focused: true })}
      onBlur={() => setStatus({ ...status, focused: false })}
    />
  );
};

export default VDatePickerInput;
